/*jslint devel: true, browser: true*/
/*globals Flickity, FB, window, ajax_urls, sendy_ajax_urls, jQuery*/

(function () {
  "use strict";

  /* ==========================================================
   * Utilities
   * ========================================================== */

  function encodeData(object) {
    return Object.keys(object)
      .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(object[k]))
      .join("&");
  }

  function createCookie(name, value, days, path) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 86400000);
      expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=" + path;
  }

  function initReachCounters() {
    const counters = document.querySelectorAll(".home-reach__counter[data-count-target]");
    if (!counters.length) return;

    const animateCounter = counter => {
      if (counter.dataset.countAnimated === "true") return;

      counter.dataset.countAnimated = "true";

      const target = parseInt(counter.dataset.countTarget, 10);
      const prefix = counter.dataset.countPrefix || "";
      const suffix = counter.dataset.countSuffix || "";
      const duration = 1700;
      const start = performance.now();

      const tick = now => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        const current = Math.round(target * eased);

        counter.textContent = prefix + current.toLocaleString() + suffix;

        if (progress < 1) {
          requestAnimationFrame(tick);
        }
      };

      requestAnimationFrame(tick);
    };

    if (!("IntersectionObserver" in window)) {
      counters.forEach(animateCounter);
      return;
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        animateCounter(entry.target);
        observer.unobserve(entry.target);
      });
    }, {threshold: 0.45});

    counters.forEach(counter => observer.observe(counter));
  }

  function initReachTabs() {
    document.querySelectorAll(".home-reach").forEach(section => {
      const tabs = section.querySelectorAll(".home-reach__stat[data-reach-tab]");
      const panes = section.querySelectorAll(".home-reach__image");
      if (!tabs.length || !panes.length) return;

      const activateTab = tab => {
        const paneId = tab.dataset.reachTab;
        const pane = section.querySelector("#" + paneId);
        if (!pane) return;

        tabs.forEach(item => item.classList.remove("active"));
        panes.forEach(item => item.classList.remove("active"));

        tab.classList.add("active");
        pane.classList.add("active");
      };

      tabs.forEach(tab => {
        tab.addEventListener("click", event => {
          if (event.target.closest("a")) return;
          activateTab(tab);
        });

        tab.addEventListener("keydown", event => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          activateTab(tab);
        });
      });
    });
  }

  /* ==========================================================
   * Banner / Header Layout
   * ========================================================== */

  function adjustPaddingBasedOnBannerState() {
    const body = document.body;
    const siteHeader = document.querySelector(".site-header");
    if (!siteHeader) return;

    const hasBanner = body.classList.contains("has-banner");
    const isTopless = body.classList.contains("topless");
    const isLinktree = body.classList.contains("page-linktree");
    const isDesktop = window.innerWidth > 1024;

    if (isLinktree) {
      body.style.paddingTop = hasBanner ? "40px" : "0px";
      siteHeader.style.top = "0";
      return;
    }

    if (hasBanner) {
      body.style.paddingTop = isDesktop ? "40px" : "100px";
      siteHeader.style.top = "40px";
    } else {
      body.style.paddingTop = isTopless
        ? isDesktop ? "0px" : "60px"
        : "60px";
      siteHeader.style.top = "0";
    }
  }

  function initBanner() {
    const banner = document.getElementById("top-banner");
    const closeBanner = document.getElementById("close-banner");

    if (document.body.classList.contains("has-banner")) {
      if (!document.cookie.includes("banner_closed_temp=true")) {
        if (banner) banner.style.display = "block";
      } else {
        document.body.classList.remove("has-banner");
        document.body.classList.add("banner-closed");
      }
    }

    adjustPaddingBasedOnBannerState();

    function forceBannerPaint() {
      if (!banner || !document.body.classList.contains("has-banner")) return;
      banner.style.display = "block";
      banner.style.transform = "translateZ(0)"; // GPU promote
      banner.style.webkitTransform = "translateZ(0)"; // iOS/WebKit safety
      void banner.offsetHeight; // force reflow
    }

    if (window.innerWidth < 768 && banner && document.body.classList.contains("has-banner")) {
      forceBannerPaint();
      requestAnimationFrame(forceBannerPaint);
      setTimeout(forceBannerPaint, 50);
      setTimeout(forceBannerPaint, 150);
      window.addEventListener("load", forceBannerPaint);
      window.addEventListener("pageshow", forceBannerPaint); // Safari/Chrome bfcache
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          forceBannerPaint();
        }
      });
    }



    if (banner && closeBanner) {
      closeBanner.addEventListener("click", function () {
        banner.style.display = "none";
        document.body.classList.remove("has-banner");
        document.body.classList.add("topless");
        createCookie("banner_closed", "true", 5, "/");
        adjustPaddingBasedOnBannerState();
      });
    }

    window.addEventListener("resize", adjustPaddingBasedOnBannerState);
  }

  /* ==========================================================
   * Countdown (server-rendered, drift-free)
   * ========================================================== */

  function initSubmitV2Countdowns() {
    const countdowns = document.querySelectorAll('.submit-v2 [data-deadline-ts]');
    if (!countdowns.length) return;

    let timer;
    function tick() {
      const now = Math.floor(Date.now() / 1000);
      let active = false;
      countdowns.forEach(el => {
        const deadline = Number(el.dataset.deadlineTs);
        const remaining = Number.isFinite(deadline) ? Math.max(0, deadline - now) : 0;
        active = active || remaining > 0;
        const units = {
          days: Math.floor(remaining / 86400),
          hrs: Math.floor((remaining % 86400) / 3600),
          min: Math.floor((remaining % 3600) / 60),
          sec: remaining % 60
        };
        el.querySelectorAll('[data-countdown-unit]').forEach(unit => {
          unit.textContent = String(units[unit.dataset.countdownUnit]).padStart(2, '0');
        });
      });
      if (!active) clearInterval(timer);
    }

    timer = setInterval(tick, 1000);
    tick();
  }

  function initCountdown() {
    const el = document.getElementById("countdown");
    if (!el || !el.dataset.deadlineTs) return;

    let remaining =
      parseInt(el.dataset.deadlineTs, 10) -
      Math.floor(Date.now() / 1000);

    if (remaining <= 0) {
      el.textContent = "CLOSING NOW";
      return;
    }

    const daysEl = el.querySelector("#days");
    const hoursEl = el.querySelector("#hours");
    const minutesEl = el.querySelector("#minutes");
    const secondsEl = el.querySelector("#seconds");

    const daysUnit = el.querySelector("#days-unit");
    const hoursUnit = el.querySelector("#hours-unit");
    const minutesUnit = el.querySelector("#minutes-unit");
    const secondsUnit = el.querySelector("#seconds-unit");

    function tick() {
      if (remaining <= 0) {
        el.textContent = "CLOSING NOW";
        clearInterval(timer);
        return;
      }

      const d = Math.floor(remaining / 86400);
      const h = Math.floor((remaining % 86400) / 3600);
      const m = Math.floor((remaining % 3600) / 60);
      const s = remaining % 60;

      daysEl.textContent = String(d).padStart(2, "0");
      hoursEl.textContent = String(h).padStart(2, "0");
      minutesEl.textContent = String(m).padStart(2, "0");
      secondsEl.textContent = String(s).padStart(2, "0");

      daysUnit.textContent = d === 1 ? "DAY" : "DAYS";
      hoursUnit.textContent = h === 1 ? "HOUR" : "HOURS";
      minutesUnit.textContent = m === 1 ? "MIN" : "MINS";
      secondsUnit.textContent = s === 1 ? "SEC" : "SECS";

      remaining--;
    }

    tick();

    // iOS Safari repaint fix
    requestAnimationFrame(() => {
      el.style.transform = "translateZ(0)";
    });

    const timer = setInterval(tick, 1000);
  }

  /* ==========================================================
   * Sliders / Layout
   * ========================================================== */

  function calculatePadding() {
    document.querySelectorAll(".slider__slide").forEach(slide => {
      const caption = slide.querySelector(".slider__caption");
      const photo = slide.querySelector(".photo");
      if (!caption || !photo) return;

      const bounds = photo.getBoundingClientRect();
      caption.style.borderTopWidth = bounds.top + bounds.height + 20 + "px";
    });
  }

  function updateSliderCaptionOverflow(slider) {
    const captions = slider
      ? slider.querySelectorAll(".slider__caption")
      : document.querySelectorAll(".slider__caption");

    captions.forEach(caption => {
      const isOverflowing = caption.scrollHeight > caption.clientHeight + 1;
      const isAtBottom = caption.scrollTop + caption.clientHeight >= caption.scrollHeight - 1;

      caption.classList.toggle("is-overflowing", isOverflowing);
      caption.classList.toggle("is-at-bottom", !isOverflowing || isAtBottom);

      if (caption.dataset.overflowBound !== "true") {
        caption.addEventListener("scroll", () => {
          const atBottom = caption.scrollTop + caption.clientHeight >= caption.scrollHeight - 1;
          caption.classList.toggle("is-at-bottom", atBottom);
        });
        caption.dataset.overflowBound = "true";
      }
    });
  }

    function initSliders() {
      const sliders = document.querySelectorAll(".js-slider");
      if (!sliders.length) return;

      // A slider CDN failure must not stop unrelated UI such as the mobile menu.
      if (typeof Flickity === "undefined") {
        console.warn("Flickity is unavailable; sliders were left in their static layout.");
        return;
      }

      sliders.forEach(slider => {
        const sliderSlides = slider.querySelectorAll(".slider__slide");
        const sliderScope = slider.closest("article") || slider.parentElement || document;
        const launchThumbs = sliderScope.querySelectorAll(".js-launch-fullscreen");
        let sliderOptions = {};

        const sliderOptionsJson = slider.dataset.sliderOptions || slider.dataset.flickity;

        if (sliderOptionsJson) {
          try {
            sliderOptions = JSON.parse(sliderOptionsJson);
          } catch (error) {
            console.warn("Invalid data-flickity config", error, slider);
          }
        }

        if (slider.classList.contains("feedback-slider") && window.matchMedia("(max-width: 768px)").matches) {
          sliderOptions.cellAlign = 0.5;
        }

        const flky = new Flickity(slider, {
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          imagesLoaded: true,
          selectedAttraction: 1,
          friction: 1,
          dragThreshold: 50,
          fullscreenPaths: { exit: "M 10,10 L 25,25 M 25,10 L 10,25" },
          ...sliderOptions,
          fullscreen: slider.dataset.fullscreen === "true" || sliderOptions.fullscreen === true,
          autoPlay: slider.dataset.autoplay || sliderOptions.autoPlay || false
        });

        const isMobileFeedbackSlider = slider.classList.contains("feedback-slider") && window.matchMedia("(max-width: 768px)").matches;

        function recenterMobileFeedback() {
          if (!isMobileFeedbackSlider) return;

          requestAnimationFrame(() => {
            flky.resize();
            if (typeof flky.reposition === "function") flky.reposition();
            flky.select(flky.selectedIndex, false, true);
          });
        }

        window.addEventListener("orientationchange", () => {
          if (slider.classList.contains("is-fullscreen")) {
            setTimeout(refreshFullscreenLayout, 250);
          }
        });

        if (window.visualViewport) {
          const handleViewportChange = () => {
            if (slider.classList.contains("is-fullscreen")) {
              refreshFullscreenLayout();
            }
          };

          window.visualViewport.addEventListener("resize", handleViewportChange);
          window.visualViewport.addEventListener("scroll", handleViewportChange);
        }

        /* ----------------------------------------
         * Image load + resize safety
         * ---------------------------------------- */
        slider.querySelectorAll("img").forEach(img => {
          if (img.complete) {
            img.dispatchEvent(new Event("load"));
          }

          img.addEventListener("load", () => {
            flky.resize();
            recenterMobileFeedback();

            if (slider.classList.contains("is-fullscreen")) {
              refreshFullscreenLayout();
            }
          });
        });

        flky.on("ready", () => {
          flky.resize();
          recenterMobileFeedback();
        });

        setTimeout(() => {
          flky.resize();
          recenterMobileFeedback();
          if (!isMobileFeedbackSlider) flky.focus();
        }, 250);

        slider.addEventListener("click", () => flky.resize());
        window.addEventListener("resize", () => {
          flky.resize();
          recenterMobileFeedback();
        });

        /* ----------------------------------------
         * Fullscreen handling
         * ---------------------------------------- */
        function refreshFullscreenLayout() {
          const run = () => {
            flky.resize();
            if (typeof flky.reposition === "function") {
              flky.reposition();
            }
            calculatePadding();
            updateSliderCaptionOverflow(slider);

            if (slider.classList.contains("is-fullscreen")) {
              placeDots();
            }
          };

          requestAnimationFrame(run);
          setTimeout(run, 60);
          setTimeout(run, 180);
          setTimeout(run, 350);
        }

        function prepareHiddenSliderForFullscreen() {
          if (!slider.classList.contains("slider--hidden") || slider.classList.contains("is-fullscreen")) {
            return;
          }

          slider.style.display = "block";
          slider.style.visibility = "hidden";
          slider.style.position = "fixed";
          slider.style.inset = "0";
          slider.style.zIndex = "-1";

          flky.resize();
          if (typeof flky.reposition === "function") {
            flky.reposition();
          }
        }

        function cleanupHiddenSliderPreparation() {
          if (!slider.classList.contains("slider--hidden") || slider.classList.contains("is-fullscreen")) {
            return;
          }

          slider.style.display = "";
          slider.style.visibility = "";
          slider.style.position = "";
          slider.style.inset = "";
          slider.style.zIndex = "";
        }

        function openFullscreenAt(index = flky.selectedIndex) {
          if (slider.classList.contains("slider--hidden") && !slider.classList.contains("is-fullscreen")) {
            prepareHiddenSliderForFullscreen();
          }

          flky.select(index, false, true);

          requestAnimationFrame(() => {
            flky.viewFullscreen();
            refreshFullscreenLayout();
          });
        }

        flky.on("fullscreenChange", isFullscreen => {
          document.body.classList.toggle("no-scroll", isFullscreen);

          if (isFullscreen) {
            slider.style.visibility = "";
            slider.style.position = "";
            slider.style.inset = "";
            slider.style.zIndex = "";
            refreshFullscreenLayout();
          } else {
            resetDots();
            cleanupHiddenSliderPreparation();
            refreshFullscreenLayout();
          }
        });

        function syncModalCaption(index) {
          const modal = slider.closest(".modal");
          if (!modal) return;

          modal.querySelectorAll(".js-submission-caption").forEach(caption => {
            caption.classList.toggle("is-active", caption.dataset.captionIndex === String(index));
          });
        }

        syncModalCaption(flky.selectedIndex || 0);

        flky.on("change", index => {
          syncModalCaption(index);

          if (slider.classList.contains("is-fullscreen")) {
            updateSliderCaptionOverflow(slider);
            setTimeout(placeDots, 0);
          }
        });

        /* ----------------------------------------
         * Click slide → fullscreen
         * ---------------------------------------- */
        if (flky.options.fullscreen === true) {
          sliderSlides.forEach((slide, index) => {
            slide.addEventListener("click", () => {
              openFullscreenAt(index);
            });
          });

          launchThumbs.forEach(thumb => {
            thumb.addEventListener("click", e => {
              if (!e.target.classList.contains("hide-button")) {
                openFullscreenAt(parseInt(thumb.dataset.count, 10));
              }
            });
          });
        }

        /* ----------------------------------------
         * Dots reposition logic
         * ---------------------------------------- */
        const dots = slider.querySelector(".flickity-page-dots");

        function placeDots() {
          if (!dots) return;
          const selectedSlide = slider.querySelector(".slider__slide.is-selected");
          if (!selectedSlide) return;

          const photoWrap = selectedSlide.querySelector(".photo__wrap");
          if (!photoWrap) return;

          photoWrap.appendChild(dots);
          dots.style.position = "absolute";
          dots.style.left = "50%";
          dots.style.transform = "translateX(-50%)";
          dots.style.bottom = "-22px";
          dots.style.zIndex = "50";
        }

        function resetDots() {
          if (!dots) return;
          slider.appendChild(dots);
          dots.removeAttribute("style");
        }

        if (slider.classList.contains("feedback-slider")) {
          const showcase = slider.closest(".feedback-showcase");
          const customDots = showcase && showcase.querySelector(".feedback-showcase__dots");
          const previousButton = showcase && showcase.querySelector(".feedback-showcase__arrow--previous");
          const nextButton = showcase && showcase.querySelector(".feedback-showcase__arrow--next");
          const cardNextButton = slider.querySelector(".flickity-prev-next-button.next");

          if (cardNextButton) {
            cardNextButton.innerHTML = '<svg class="feedback-card-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 7l5 5-5 5"/></svg>';
          }

          if (customDots) {
            sliderSlides.forEach((slide, index) => {
              const dot = document.createElement("button");
              dot.type = "button";
              dot.className = "feedback-showcase__dot";
              dot.setAttribute("aria-label", `Show review ${index + 1}`);
              dot.addEventListener("click", () => flky.select(index));
              customDots.appendChild(dot);
            });

            const syncFeedbackControls = index => {
              const feedbackDots = customDots.querySelectorAll(".feedback-showcase__dot");
              const dotCount = feedbackDots.length;
              const visibleDistance = isMobileFeedbackSlider ? 1 : 2;

              feedbackDots.forEach((dot, dotIndex) => {
                const isActive = dotIndex === index;
                let relativePosition = dotIndex - index;

                if (relativePosition > dotCount / 2) relativePosition -= dotCount;
                if (relativePosition < -dotCount / 2) relativePosition += dotCount;

                const distance = Math.abs(relativePosition);

                dot.classList.toggle("is-active", isActive);
                dot.classList.toggle("is-visible", distance <= visibleDistance);
                dot.classList.toggle("is-edge", distance === visibleDistance);
                dot.setAttribute("aria-current", isActive ? "true" : "false");
                dot.tabIndex = distance <= visibleDistance ? 0 : -1;
                dot.style.order = relativePosition;
              });
            };

            syncFeedbackControls(flky.selectedIndex || 0);
            flky.on("change", syncFeedbackControls);
          }

          if (previousButton) previousButton.addEventListener("click", () => flky.previous());
          if (nextButton) nextButton.addEventListener("click", () => flky.next());
        }

        slider.flickity = flky;
      });

      window.addEventListener("resize", function () {
        calculatePadding();
        if (window.salvattore) {
          window.salvattore.rescanMediaQueries();
        }
      });
    }

    /* ==========================================================
    * Mini FAQ
    * ========================================================== */

    const faqItems = document.querySelectorAll(
    ".mini-faq-section__content-item-question"
    );

    faqItems.forEach((button) => {
    const toggleFaqItem = () => {
      const answer = button.nextElementSibling;
      const plus = button.querySelector(".faq-plus");
      const minus = button.querySelector(".faq-minus");

      if (!answer) return;

      // Toggle answer
      answer.classList.toggle("open");

      // Toggle icons
      if (plus) plus.classList.toggle("hidden");
      if (minus) minus.classList.toggle("hidden");

      const isExpanded = answer.classList.contains("open");
      button.setAttribute("aria-expanded", String(isExpanded));
    };

    button.addEventListener("click", toggleFaqItem);
    button.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      toggleFaqItem();
    });
    });

    /* ==========================================================
    * Mobile menu
    * ========================================================== */

    function initMobileMenu() {
      const menuToggle = document.querySelector(".menu-toggle");
      const menuWrap = document.querySelector(".close-wrap");
      const mainNavigation = document.querySelector(".main-navigation");
      const masthead = document.getElementById("masthead");

      if (!menuToggle || !menuWrap || !mainNavigation || !masthead) return;

      const isPortfolioHeader = masthead.classList.contains("site-portfolio-header");

      menuToggle.addEventListener("click", function () {
        menuWrap.classList.toggle("closed");
        menuToggle.classList.toggle("active");
        mainNavigation.classList.toggle("menu-open");
        document.body.classList.toggle("menu-is-open", mainNavigation.classList.contains("menu-open"));

        if (!isPortfolioHeader) {
          masthead.classList.toggle(
            "opaque",
            window.scrollY > 100 || menuToggle.classList.contains("active")
          );
        }
      });
    }


    /* ==========================================================
    * Opacity Header
    * ========================================================== */

    function initHeaderOpacity() {
      const masthead = document.getElementById("masthead");
      const menuToggle = document.querySelector(".menu-toggle");
      if (!masthead) return;

      const isPortfolioHeader = masthead.classList.contains("site-portfolio-header");

      function update() {
        if (isPortfolioHeader) {
          masthead.classList.remove("opaque");
          return;
        }

        masthead.classList.toggle(
          "opaque",
          window.scrollY > 100 || (menuToggle && menuToggle.classList.contains("active"))
        );
      }

      window.addEventListener("scroll", update, { passive: true });
      update();
    }



  /* ==========================================================
   * UI helpers (clipboard, expands, modals)
   * ========================================================== */

  function initUIHelpers() {
    document.querySelectorAll(".copyToClipboardButton").forEach(btn => {
      btn.addEventListener("click", function () {
        const ta = document.createElement("textarea");
        ta.value = window.location.href;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);

        const original = btn.innerHTML;
        btn.innerHTML = "copied!";
        setTimeout(() => (btn.innerHTML = original), 2000);
      });
    });

    document.querySelectorAll(".js-expands").forEach(el =>
      el.addEventListener("click", () => el.classList.add("expanded"))
    );

    document.querySelectorAll(".menu-item-has-children").forEach(el =>
      el.addEventListener("click", () => el.classList.add("expanded"))
    );

    document.querySelectorAll(".js-modal-close").forEach(el =>
      el.addEventListener("click", e => {
        e.preventDefault();
        document.body.classList.remove("has-modal");
      })
    );

    function selectCaptionIndex(drawer, index) {
      if (!drawer || typeof index === "undefined") return;
      const toggle = drawer.querySelector(`.js-caption-select[data-caption-index="${index}"]`);
      if (toggle) {
        toggle.click();
      }
    }

    function refreshCaptionOverflow() {
      document.querySelectorAll(".submission-caption__description").forEach(description => {
        const isOverflowing = description.scrollHeight > description.clientHeight + 1;
        const isAtBottom = description.scrollTop + description.clientHeight >= description.scrollHeight - 1;

        description.classList.toggle("is-overflowing", isOverflowing);
        description.classList.toggle("is-at-bottom", !isOverflowing || isAtBottom);

        if (description.dataset.captionScrollBound !== "true") {
          description.addEventListener("scroll", () => {
            const atBottom = description.scrollTop + description.clientHeight >= description.scrollHeight - 1;
            description.classList.toggle("is-at-bottom", atBottom);
          });
          description.dataset.captionScrollBound = "true";
        }
      });
    }

    refreshCaptionOverflow();
    window.addEventListener("resize", refreshCaptionOverflow);

    document.querySelectorAll(".js-caption-drawer-open").forEach(btn =>
      btn.addEventListener("click", e => {
        e.preventDefault();
        const modal = btn.closest(".modal");
        const targetId = modal ? modal.dataset.captionDrawerTarget : "";
        const drawer = targetId
          ? document.getElementById(targetId)
          : btn.closest("article, .modal, body").querySelector(".caption-drawer") || document.querySelector(".caption-drawer");
        if (!drawer) return;
        selectCaptionIndex(drawer, btn.dataset.captionIndex);
        drawer.classList.add("is-open");
        drawer.setAttribute("aria-hidden", "false");
        document.body.classList.add("has-caption-drawer");
      })
    );

    // Submission modals on My Submissions are fetched and inserted after the
    // initial page load. Keep a delegated fallback so their caption buttons do
    // not depend on page-specific rebinding code having run successfully.
    document.addEventListener("click", e => {
      const btn = e.target.closest(".js-caption-drawer-open");
      if (!btn) return;

      const modal = btn.closest(".modal");
      const targetId = modal ? modal.dataset.captionDrawerTarget : "";
      const drawer = targetId
        ? document.getElementById(targetId)
        : btn.closest("article, .modal, body").querySelector(".caption-drawer") || document.querySelector(".caption-drawer");

      if (!drawer || drawer.classList.contains("is-open")) return;

      e.preventDefault();
      selectCaptionIndex(drawer, btn.dataset.captionIndex);
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("has-caption-drawer");
    });

    document.querySelectorAll(".js-caption-drawer-close").forEach(btn =>
      btn.addEventListener("click", e => {
        e.preventDefault();
        const drawer = btn.closest(".caption-drawer");
        if (!drawer) return;
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        document.body.classList.remove("has-caption-drawer");
      })
    );

    document.querySelectorAll(".js-caption-select").forEach(btn =>
      btn.addEventListener("click", e => {
        e.preventDefault();
        const item = btn.closest(".caption-drawer__item");
        const drawer = btn.closest(".caption-drawer");
        if (!item || !drawer) return;

        drawer.querySelectorAll(".caption-drawer__item").forEach(row => {
          const active = row === item;
          row.classList.toggle("is-active", active);
          const toggle = row.querySelector(".js-caption-select");
          if (toggle) {
            toggle.setAttribute("aria-pressed", active ? "true" : "false");
          }
        });

        drawer.querySelectorAll(".caption-drawer__fields").forEach(fields => {
          fields.classList.toggle("is-active", fields.dataset.captionIndex === btn.dataset.captionIndex);
        });
      })
    );

    document.querySelectorAll(".js-caption-form").forEach(form =>
      form.addEventListener("submit", e => {
        e.preventDefault();

        const message = form.querySelector(".js-caption-message");
        const submit = form.querySelector(".caption-drawer__save");
        if (submit) submit.disabled = true;
        if (message) {
          message.hidden = false;
          message.textContent = "Saving...";
        }

        fetch(form.getAttribute("action"), {
          method: "POST",
          credentials: "same-origin",
          body: new FormData(form)
        })
          .then(response => response.json())
          .then(data => {
            if (!data || !data.success) {
              throw new Error(data && data.data && data.data.message ? data.data.message : "Could not save captions.");
            }
            if (message) {
              message.hidden = false;
              message.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m8 12.33 2.46 2.67L16 9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" stroke="#00a806" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' + (data.data && data.data.message ? data.data.message : "All changes saved");
            }
            if (data.data && Array.isArray(data.data.images)) {
              data.data.images.forEach((image, index) => {
                document.querySelectorAll(`.js-submission-caption[data-caption-index="${index}"]`).forEach(caption => {
                  const title = caption.querySelector(".submission-caption__title");
                  const description = caption.querySelector(".submission-caption__description");
                  const nextTitle = image && image.title ? image.title : "";
                  const nextDescription = image && image.description ? image.description : "";

                  if (title) {
                    title.textContent = nextTitle;
                    title.hidden = !nextTitle;
                  }
                  if (description) {
                    description.textContent = nextDescription;
                    description.hidden = !nextDescription;
                  }
                });
              });
              refreshCaptionOverflow();
            }
          })
          .catch(error => {
            if (message) {
              message.hidden = false;
              message.textContent = error.message;
            }
          })
          .finally(() => {
            if (submit) submit.disabled = false;
          });
      })
    );

    function expandRulesFromHash() {
      if (window.location.hash === "#rules") {
        const rules = document.getElementById("rules");
        if (rules) rules.classList.add("expanded");
      }
    }

    expandRulesFromHash();
    window.addEventListener("hashchange", expandRulesFromHash);
  }

  /* ==========================================================
   * Share / FB
   * ========================================================== */

  function initShare() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: 1228012153928649,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v3.3"
      });
    };

    function openShareDialog(url) {
      const w = 500, h = 500;
      const left = (screen.width - w) / 2;
      const top = (screen.height - h) / 2;
      window.open(
        url,
        "NewWindow",
        `width=${w},height=${h},left=${left},top=${top}`
      );
    }

    document.addEventListener("click", function (e) {
      if (e.target.matches(".js-facebook-share-button") ||
          e.target.matches(".js-twitter-share-button")) {
        openShareDialog(e.target.dataset.shareUrl);
      }
    });

    document.querySelectorAll(".js-share").forEach(btn =>
      btn.addEventListener("click", e => {
        e.preventDefault();
        FB.ui({ method: "share", href: btn.href });
      })
    );
  }

  /* ==========================================================
   * Popups
   * ========================================================== */

  function initPopups($) {
    $(".cd-popup-trigger").on("click", function (e) {
      e.preventDefault();
      $(".cd-popup").addClass("is-visible");
    });

    $(window).on("scroll", function () {
      if (
        document.getElementById("popupactive") &&
        $(window).scrollTop() >= ($(document).height() - $(window).height()) * 0.5 &&
        localStorage.getItem("popState") !== "shown"
      ) {
        $(".cd-popup").addClass("is-visible");
        localStorage.setItem("popState", "shown");
      }
    });

    $(".cd-popup").on("click", function (e) {
      if ($(e.target).is(".cd-popup, .cd-popup-close")) {
        e.preventDefault();
        $(this).removeClass("is-visible");
      }
    });

    $(document).keyup(function (e) {
      if (e.which === 27) $(".cd-popup").removeClass("is-visible");
    });
  }

  /* ==========================================================
   * Site notices
   * ========================================================== */

  function buildSiteNoticeMarkup(type, message) {
    const iconMarkup = type === "success"
      ? '<svg viewBox="0 0 24 24" focusable="false"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>'
      : '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/></svg>';

    return [
      '<div class="site-notice site-notice--' + type + ' js-site-notice" role="' + (type === "error" ? "alert" : "status") + '">',
        '<span class="site-notice__icon" aria-hidden="true">' + iconMarkup + '</span>',
        '<p class="site-notice__message">' + message + '</p>',
        '<button type="button" class="site-notice__close js-site-notice-close" aria-label="Close notification">',
          '<svg viewBox="0 0 24 24" focusable="false"><path d="M6 6 18 18M18 6 6 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.8"/></svg>',
        '</button>',
      '</div>'
    ].join("");
  }

  function getSiteNoticeFromQuery() {
    const params = new URLSearchParams(window.location.search);
    const type = params.get("tip_notice");
    const key = params.get("tip_notice_key");

    const messages = {
      success: {
        login_success: "You are now logged in.",
        logout_success: "You have been logged out.",
        register_success: "Your account has been created successfully.",
        portfolio_saved: "Changes Saved!"
      },
      error: {
        login_error: "We could not log you in. Please check your details and try again.",
        register_error: "We could not create your account. Please review the form and try again."
      }
    };

    if (!type || !key || !messages[type] || !messages[type][key]) {
      return null;
    }

    params.delete("tip_notice");
    params.delete("tip_notice_key");

    const query = params.toString();
    const nextUrl = window.location.pathname + (query ? "?" + query : "") + window.location.hash;
    window.history.replaceState({}, document.title, nextUrl);

    return {
      type,
      message: messages[type][key]
    };
  }

  function initSiteNotices() {
    let notices = document.querySelectorAll(".js-site-notice");

    if (!notices.length) {
      const queryNotice = getSiteNoticeFromQuery();

      if (queryNotice) {
        let stack = document.querySelector(".site-notice-stack");

        if (!stack) {
          stack = document.createElement("div");
          stack.className = "site-notice-stack";
          stack.setAttribute("aria-live", "polite");
          stack.setAttribute("aria-atomic", "true");
          document.body.appendChild(stack);
        }

        stack.innerHTML = buildSiteNoticeMarkup(queryNotice.type, queryNotice.message);
        notices = stack.querySelectorAll(".js-site-notice");
      }
    }

    if (!notices.length) return;

    notices.forEach(notice => {
      const closeButton = notice.querySelector(".js-site-notice-close");
      let timeoutId = null;

      const dismiss = () => {
        notice.classList.add("is-dismissing");
        window.clearTimeout(timeoutId);
        window.setTimeout(() => notice.remove(), 220);
      };

      closeButton?.addEventListener("click", dismiss);
      timeoutId = window.setTimeout(dismiss, 4200);
    });
  }

  /* ==========================================================
   * Language switcher
   * ========================================================== */

  function initLangSwitcher() {
    document.querySelectorAll(".lang-switch").forEach(sw => {
      sw.addEventListener("click", e => {
        e.preventDefault();
        const prev = document.documentElement.lang;
        document.documentElement.lang = sw.hash.substring(1);
        sw.href = "#" + prev;
        sw.innerHTML = prev;
      });
    });
  }

  /* ==========================================================
   * Pricing toggle
   * ========================================================== */

  function initPricingToggle() {
    const cb = document.getElementById("pricing-checkbox");
    if (!cb) return;

    function update() {
      document.querySelectorAll(".pricing-button2").forEach(b =>
        (b.style.display = cb.checked ? "none" : "block")
      );
      document.querySelectorAll(".pricing-button3").forEach(b =>
        (b.style.display = cb.checked ? "block" : "none")
      );
    }

    cb.addEventListener("change", update);
    update();
  }

  /* ==========================================================
   * Portfolio theme preview
   * ========================================================== */

  function initThemePreview() {
    document.querySelectorAll("[data-theme-preview]").forEach(preview => {
      const buttons = preview.querySelectorAll("[data-theme-preview-button]");
      const panels = preview.querySelectorAll("[data-theme-preview-panel]");

      buttons.forEach(button => {
        button.addEventListener("click", () => {
          const target = button.getAttribute("data-theme-preview-button");

          buttons.forEach(item => {
            const active = item === button;
            item.classList.toggle("active", active);
            item.setAttribute("aria-selected", active ? "true" : "false");
          });

          panels.forEach(panel => {
            const active = panel.getAttribute("data-theme-preview-panel") === target;
            panel.classList.toggle("active", active);
            panel.hidden = !active;
          });
        });
      });
    });
  }

  /* ==========================================================
   * UM Cover Fix
   * ========================================================== */

  function initUMCoverFix() {
    if (window.location.search.includes("um_action=edit")) return;

    const trigger = document.querySelector(".um-cover-add");
    if (!trigger) return;

    const clone = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(clone, trigger);

    clone.addEventListener(
      "click",
      e => {
        e.preventDefault();
        e.stopPropagation();
        const url = new URL(window.location.href);
        url.searchParams.set("um_action", "edit");
        window.location.href = url.toString();
      },
      true
    );
  }

/* ==========================================================
 * Past Edition Toggle
 * ========================================================== */

  function initPastEditions() {
    const select = document.getElementById("edition-select");
    if (!select) return;

    const editions = document.querySelectorAll(".pasteditions .fulledition");

    select.addEventListener("change", function () {
      const chosen = this.value;

      editions.forEach((edition, idx) => {
        edition.style.display =
          chosen !== "" && String(idx) === chosen ? "block" : "none";
      });
    });
  }


  /* ==========================================================
   * Submenu Toggle
   * ========================================================== */

  function initSubmenuToggle() {
    const toggles = document.querySelectorAll(".submenu-toggle");

    toggles.forEach(toggle => {
      toggle.addEventListener("click", function () {
        this.classList.toggle("submenu-toggle--open");

        const subMenu = this.querySelector(".sub-menu");
        if (subMenu) {
          subMenu.classList.toggle("sub-menu--open");
        }
      });
    });
  }

  /* ==========================================================
   * Entry point
   * ========================================================== */

  document.addEventListener("DOMContentLoaded", function () {

    /* Currency detection */
    if (
      !document.cookie.includes('currency_manual=true') &&
      !document.cookie.match(/(^|;)\s*currency=/)
    ) {
      const lang = navigator.language.slice(0, 2);
      const euroLangs = [
        'fr','de','it','es','nl','pt','fi','el',
        'ga','lv','lt','et','sk','sl','mt','hr'
      ];

      const currency = euroLangs.includes(lang) ? 'EUR' : 'USD';
      createCookie('currency', currency, 30, '/');

      location.reload();
    }

    /* Click handler */
    document.querySelectorAll('.currency-switcher button').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        createCookie('currency', btn.dataset.currency, 30, '/');
        createCookie('currency_manual', 'true', 30, '/');
        location.reload();
      });
    });

    /* Visual state */
    const current =
      (document.cookie.match(/(?:^|; )currency=([^;]+)/) || [])[1] || 'USD';

    document.querySelectorAll('.currency-switcher button').forEach(btn => {
      const isSelected = btn.dataset.currency === current;
      btn.classList.toggle('is-selected', isSelected);
      btn.disabled = isSelected;
      isSelected
        ? btn.setAttribute('aria-current', 'true')
        : btn.removeAttribute('aria-current');
    });

    initBanner();
    initCountdown();
    initSubmitV2Countdowns();
    initSliders();
    initUIHelpers();
    initShare();
    initLangSwitcher();
    initPricingToggle();
    initThemePreview();
    initUMCoverFix();
    initSubmenuToggle();
    initMobileMenu();
    initHeaderOpacity();
    initPastEditions();
    initSiteNotices();
    initReachCounters();
    initReachTabs();

    if (window.jQuery) {
      jQuery(document).ready(function ($) {
        initPopups($);
        // Sendy forms (unchanged logic)
        function bind(form, email, tags) {
          $(form).on("submit", e => {
            e.preventDefault();
            const formTags = $(`${form} [name="TAGS"]`).val() || tags;
            $.post(sendy_ajax_urls.admin_ajax, {
              action: "subscribe_to_sendy",
              email: $(email).val(),
              tags: formTags,
              gdpr: true
            }).done(res => {
              const msg =
                res === "1"
                  ? "Subscription successful!"
                  : res === "Already subscribed."
                  ? "You are already subscribed."
                  : "Subscription failed.";
              $(form + " .message-sendy")
                .html(`<div>${msg}</div>`)
                .addClass("is-active");
            });
          });
        }

        bind("#subscribe-form-sendy-footer", "#email-sendy-footer", "Footer");
        bind("#subscribe-form-sendy-popup", "#whiteph-popup", "NL-Popup");
        bind("#subscribe-form-sendy-linktree", "#email-sendy-linktree", "Linktree");
        bind("#subscribe-form-sendy-portfolio-lifetime", "#email-sendy-portfolio-lifetime", "Portfolio-Lifetime-Pro-IG");
        bind("#subscribe-form-sendy-theme-hub", "#email-sendy-theme-hub", "SEO-Hub-Travel");
      });
    }
  });

})();

document.addEventListener('DOMContentLoaded', () => {
    jQuery(document).ready(function ($) {
        $('#builderStepMenu li').on('click', function () {
            var stepIndex = $(this).data('step');
            $('#profile-stepper-form .steps li').eq(stepIndex).find('a').click();
        });
    });

    const menuItems = document.querySelectorAll("#builderStepMenu .site-header__nav-item");

    menuItems.forEach(item => {
        item.addEventListener("click", function () {
            const stepIndex = parseInt(item.getAttribute("data-step"));

            const stepElement = document.querySelectorAll("#profile-stepper-form .steps li")[stepIndex];
            if (stepElement) {
                stepElement.querySelector("a").click();
            }

            menuItems.forEach(el => el.classList.remove("active"));
            item.classList.add("active");
        });
    });
});
